import { horaAr } from "../../shared/fechaAr";
import Patente from "../funcionales/Patente";

/* La lista de coincidencias, debajo del campo que se está escribiendo
 * (Guillermo, tickets 389 y 394: «casi como un auto completar»). La usan
 * «Registrar entrada» y «Agregar» de la lista de autorizados (ticket 441).
 *
 * Va DEBAJO del campo y empuja el resto, no flota encima: en el celular, con
 * el teclado abierto, una lista flotante tapa justo lo que se quiere tocar.
 *
 * `nota(s)` agrega algo al renglón chico de cada opción (en «Agregar», si ya
 * está en la lista o si está dado de baja). */
const Sugerencias = ({ id, items, onElegir, nota }) =>
  items.length === 0 ? null : (
    <ul className="vig-sug" id={id} role="listbox" aria-label="Coincidencias">
      {items.map((s) => (
        <li key={s.clave} role="presentation">
          <button
            type="button"
            role="option"
            aria-selected="false"
            className="vig-sug-op"
            /* `onMouseDown` evita que el campo pierda el foco antes del toque:
               si lo pierde, el teclado se cierra y la lista salta. */
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onElegir(s)}
          >
            {s.patente ? (
              <Patente dominio={s.patente} />
            ) : (
              <span className="sin-dato">sin patente</span>
            )}
            <span className="vig-sug-txt">
              <b>{s.nombre || "sin nombre"}</b>
              <small>
                {s.detalle || (s.tipo === "autorizado" ? "autorizado" : "")}
                {s.tipo === "reciente" ? " · no está en autorizados" : ""}
                {nota ? nota(s) : ""}
                {s.adentro ? ` · adentro desde las ${horaAr(s.adentro.entrada)}` : ""}
              </small>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );

export default Sugerencias;
